import { asyncLoad } from '@util'

const Planner = asyncLoad(() =>
  import('@components/LocalMerchant/ContentManage/Panner')
)
const PlannerDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ContentManage/PannerDetail')
)
const Photography = asyncLoad(() =>
  import('@components/LocalMerchant/ContentManage/Photography')
)
const PhotographyDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ContentManage/PhotographyDetail')
)

export default [
  {
    path: 'planner',
    component: Planner,
    stat: '策划师管理'
  },
  {
    path: 'planner/:id',
    component: PlannerDetail,
    stat: '新增策划师'
  },
  {
    path: 'photography',
    component: Photography,
    stat: '摄影师管理'
  },
  {
    path: 'photography/:id',
    component: PhotographyDetail,
    stat: '新增摄影师'
  }
]
